module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid47_1020x882.daa8099.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid47_1020x882.jpg
// module id = vxPk
// module chunks = 0